import { lazy, Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import Loader from '../../shared/ui/Loader'

const StartPage = lazy(() => import('../../pages/StartPage'))
const LoginPage = lazy(() => import('../../pages/LoginPage'))
const RegisterPage = lazy(() => import('../../pages/RegisterPage'))

export const getAuthRoutes = () => [
  {
    path: '/',
    element: (
      // Обертка Suspense для всех дочерних роутов
      <Suspense fallback={<Loader fullScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        index: true, // Указывает, что это роут по умолчанию для '/'
        element: <StartPage />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'register',
        element: <RegisterPage />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate replace to="/" />,
  },
]
